<body>
    <div class="box">
        <h2>M.R. Login</h2>
        <form (ngSubmit)="onSubmit()" [formGroup]="mrform">
            <div class="inputBox">
                <input type="email" formControlName="email"  name="email" required onkeyup="this.setAttribute('value', this.value);" value="">
                <label>Username</label>
            </div>
            <div class="inputBox">
                <input type="password" formControlName="password"  name="password" required value=""
                    onkeyup="this.setAttribute('value', this.value);" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                    title="Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters">
                <label>Password</label>
            </div>
            <input type="submit" name="sign-in" value="Sign In">
        </form>
        <br />
        <p>NEW USER?<a href="/mrSignup">Log in</a></p>
        <p>login as company <a href="/Company">Log in</a></p>
    </div>
</body>